module.exports = __webpack_public_path__ + "f80f1cb346c249289d20dd168bffb394.png";